import _extends from "@babel/runtime/helpers/extends";
import { AnnouncementModalLayout, Text } from '@wix/design-system';
import React from 'react';
import ErrorIllustration from '../../assets/images/error.svg';
import { reportErrorModalCTAClick } from '../../bi/bi';
import { getFootNoteProps } from './getFootNoteProps';
import { getAppName } from '../../selectors/appRuntimeReader';
import { useInstallerContext } from '../../context/InstallerContext';
import { useLibraryTranslations } from '../../context/TranslationsContext';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
export const ErrorModal = () => {
  var _errorObj$cta, _errorObj$learnMore, _errorObj$cta2, _errorObj$learnMore2;
  const transProps = useLibraryTranslations();
  const {
    t
  } = transProps;
  const {
    modals
  } = useModalsAndWindow();
  const {
    modalProps: errorObj
  } = modals.error;
  const {
    retryInstallation
  } = useRenderControl();
  const {
    preInstallationData: {
      app
    }
  } = useInstallerContext();
  const appName = getAppName(app);
  const showStatusFootnoteProps = getFootNoteProps({
    showStatusFootnote: errorObj.showStatusFootnote,
    transProps
  });
  const retryInstallationOnClick = () => {
    var _errorObj$error;
    reportErrorModalCTAClick('retry-installation', ((_errorObj$error = errorObj.error) == null ? void 0 : _errorObj$error.toString()) || '');
    retryInstallation();
  };
  const retryInstallationButtonProps = errorObj.showRetryInstallation ? {
    secondaryButtonText: t('errors.try-again', {
      defaultValue: 'Try Again'
    }),
    secondaryButtonOnClick: retryInstallationOnClick
  } : {};
  const secondaryButtonText = (errorObj == null || (_errorObj$cta = errorObj.cta) == null ? void 0 : _errorObj$cta.textKey) && t(errorObj.cta.textKey, {
    defaultValue: 'Done'
  });
  const learnMoreText = (errorObj == null || (_errorObj$learnMore = errorObj.learnMore) == null ? void 0 : _errorObj$learnMore.textKey) && t(errorObj.learnMore.textKey, {
    defaultValue: 'Learn more'
  });
  const secondaryOnClick = errorObj != null && (_errorObj$cta2 = errorObj.cta) != null && _errorObj$cta2.onClick ? () => {
    var _errorObj$error2, _errorObj$cta3;
    reportErrorModalCTAClick(secondaryButtonText || '', ((_errorObj$error2 = errorObj.error) == null ? void 0 : _errorObj$error2.toString()) || '');
    (_errorObj$cta3 = errorObj.cta) == null || _errorObj$cta3.onClick();
  } : undefined;
  const learnMoreOnClick = errorObj != null && (_errorObj$learnMore2 = errorObj.learnMore) != null && _errorObj$learnMore2.onClick ? () => {
    var _errorObj$error3, _errorObj$learnMore3;
    reportErrorModalCTAClick(learnMoreText || '', ((_errorObj$error3 = errorObj.error) == null ? void 0 : _errorObj$error3.toString()) || '');
    errorObj == null || (_errorObj$learnMore3 = errorObj.learnMore) == null || _errorObj$learnMore3.onClick();
  } : undefined;
  return /*#__PURE__*/React.createElement(AnnouncementModalLayout, _extends({
    dataHook: "error-modal-layout",
    illustration: errorObj.customIllustration ?? /*#__PURE__*/React.createElement(ErrorIllustration, null),
    title: t(errorObj.customTitleKey ?? 'error-modal.title', {
      defaultValue: 'Seems That Something Is Wrong'
    }),
    secondaryButtonText: secondaryButtonText,
    secondaryButtonOnClick: secondaryOnClick,
    linkText: learnMoreText,
    linkOnClick: learnMoreOnClick,
    onCloseButtonClick: () => {
      var _errorObj$error4;
      reportErrorModalCTAClick('close', ((_errorObj$error4 = errorObj.error) == null ? void 0 : _errorObj$error4.toString()) || 'error not found');
      modals.error.close({
        answer: 'PROCEED'
      });
    }
  }, retryInstallationButtonProps, showStatusFootnoteProps), /*#__PURE__*/React.createElement(Text, null, t(errorObj.messageKey || '', {
    appName,
    defaultValue: 'Installer did not start due to a technical issue (prerequisites were not fulfilled).'
  })));
};
//# sourceMappingURL=ErrorModal.js.map